import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, alert_message_html,
         populate_order_with_lines } from '../../../common'

$(init)

async function init () {
  let $page = $('#order-list-page')
  if ($page.length == 0) {
    return
  }
  try {
    let myinfo = await get_myinfo()
    let loggedin = has_user_loggedin(myinfo)
    if (!loggedin) {
      $page.find('.loading-indicator').addClass('d-none')
      return
    }
    let orders = (await get_json(`/api/order/list`)).data
    $page.find('.loading-indicator').addClass('d-none')
    if (orders.length == 0) {
      $page.find('.orders-empty').removeClass('d-none')
      return
    }
    let $orders = $page.find('.orders')
    $orders.removeClass('d-none')
    update_orders(orders)
    function update_orders (orders) {
      $orders.html('')
      for (let order of orders) {
        populate_order_with_lines(order)
        $orders.append(eval_html_template('#order-template', order))
      }
    }
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}
